module.exports = __webpack_public_path__ + "img/special2.61a64386.jpg";